import {
  Box,
  Button,
  Drawer,
  Flex,
  Heading,
  Image,
  Spacer,
  Text,
  VStack
} from "@chakra-ui/react"
import { useState } from "react"
import { Link as RouterLink, useLocation } from "react-router-dom"

const Navbar: React.FC = () => {
  const location = useLocation() // Get current route
  const [open, setOpen] = useState(false) // Control mobile menu

  const isActive = (path: string) => location.pathname === path

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "Team", path: "/team" },
    { name: "Contact", path: "/contact" }
  ]

  const handleCloseDrawer = () => {
    setOpen(false)
  }

  return (
    <Flex as="nav" px={8} py={4} boxShadow="sm" align="center">
      {/* Logo */}
      <Heading size="md" color="brand.700">
        <RouterLink to="/">
          <Image w={120} src="/greenflip_logo.png" alt="GreenFlip" />
        </RouterLink>
      </Heading>

      <Spacer />

      {/* Desktop Menu (Hidden on mobile) */}
      <Flex gap={6} display={{ base: "none", md: "flex" }}>
        {menuItems.map(({ name, path }) => (
          <Box
            key={path}
            pb={1}
            borderBottom={isActive(path) ? "2px solid" : "none"}
            borderColor="brand.600"
          >
            <RouterLink to={path}>
              <Text
                fontWeight="400"
                color={isActive(path) ? "brand.700" : "gray.600"}
                _hover={{ color: "brand.600" }}
                transition="color 0.2s ease-in-out"
              >
                {name}
              </Text>
            </RouterLink>
          </Box>
        ))}
      </Flex>

      <Spacer />

      {/* Contact Button (Hidden on mobile) */}
      <Box display={{ base: "none", md: "block" }}>
        <RouterLink to="/login">
          <Button bg="black.900" variant="outline">
            Sign in
          </Button>
        </RouterLink>
      </Box>

      {/* Hamburger Menu Button (Only visible on mobile) */}
      <Image
        src="/images/menu-icon.png"
        w={30}
        h={30}
        onClick={() => setOpen(true)}
        display={{ base: "flex", md: "none" }}
        cursor="pointer"
      />

      {/* Mobile Menu Drawer */}
      <Drawer.Root
        open={open}
        onOpenChange={(e: { open: boolean }) => setOpen(e.open)}
        placement="end"
        modal={true}
      >
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.CloseTrigger />
            <Drawer.Header> </Drawer.Header>
            <Drawer.Body>
              <VStack gap={6} alignItems="flex-start">
                {menuItems.map(({ name, path }) => (
                  <Text
                    key={path}
                    onClick={handleCloseDrawer}
                    borderBottom={isActive(path) ? "2px solid" : "none"}
                    borderColor="brand.500"
                    color={
                      isActive(path)
                        ? "var(--chakra-colors-brand-700)"
                        : "var(--chakra-colors-gray-600)"
                    }
                  >
                    <RouterLink
                      to={path}
                      style={{
                        fontWeight: "400",
                        color: isActive(path)
                          ? "var(--chakra-colors-brand-700)"
                          : "var(--chakra-colors-gray-600)",
                        transition: "color 0.2s ease-in-out"
                      }}
                    >
                      {name}
                    </RouterLink>
                  </Text>
                ))}

                {/* Contact Button in Mobile Menu */}
                <RouterLink to="/login">
                  <Button
                    bg="brand.600"
                    color="white"
                    _hover={{ bg: "brand.700" }}
                    onClick={handleCloseDrawer}
                  >
                    Sign in
                  </Button>
                </RouterLink>
              </VStack>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Drawer.Root>
    </Flex>
  )
}

export default Navbar
